module.exports = __webpack_public_path__ + "media/components/locations/shared/images/hero-94a3176ebe1aec00482294754084ba49.png";